import React, { useRef } from "react";
import { bool, func } from "prop-types";
import { useTranslation } from "@lib/i18n";

import Typography from "@components/shared/Typography";
import RequestButton from "@components/shared/RequestButton";
import Modal from "@components/shared/Modal";

/**
 * Informs the customer that the delivery method stored on their deal is no
 * longer available (e.g. it got disabled for the market, or assisted sales
 * were switched off) and sends them back to the delivery selection.
 */
const DeliveryMethodUnavailableModal = ({ isOpen, onConfirm }) => {
  const { t } = useTranslation();

  const modalFirstElement = useRef(null);

  return (
    <Modal
      ariaLabel={t("basket.delivery.title")}
      disableBackdropClick
      firstElement={modalFirstElement}
      isOpen={isOpen}
      onClose={onConfirm}
    >
      <div
        className="flex flex-col items-center h-full gap-8 py-4 text-center"
        data-id="delivery-method-unavailable-modal-container"
      >
        <h4 className="text-xl font-semibold">{t("basket.delivery.title")}</h4>
        <Typography>
          {t("basket.errorMessages.deliveryMethodIsUnavailable")}
        </Typography>
        <div className="flex flex-wrap items-center justify-center gap-4 w-full">
          <RequestButton
            data-id="delivery-method-unavailable-modal-confirm-btn"
            ref={modalFirstElement}
            triggerRequestCallback={onConfirm}
          >
            {t("general.continue")}
          </RequestButton>
        </div>
      </div>
    </Modal>
  );
};

DeliveryMethodUnavailableModal.propTypes = {
  isOpen: bool.isRequired,
  onConfirm: func.isRequired,
};

export default DeliveryMethodUnavailableModal;
